var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function createFontFaces(def, assetResolver) {
    return def.variants
        .map(function (v) { return createFontVariantFragment(def, v, assetResolver); })
        .map(function (fragment) { return "\n    @font-face {\n      font-family: \"".concat(def.name, "\";\n      ").concat(fragment, "\n    }\n  "); })
        .join("\n");
}
function createFontVariantFragment(def, variant, assetResolver) {
    return "\n    font-weight: ".concat(variant.fontWeight, ";\n    font-style: ").concat(variant.fontStyle, ";\n    ").concat(createFontSrc(def, variant, assetResolver), "\n  ");
}
function createFontSrc(def, variant, assetResolver) {
    var formats = __spreadArray(__spreadArray([], __read((def.defaultFormats || [])), false), __read((variant.formats || [])), false);
    var ieFormat = formats.find(function (x) { return x.format === null; });
    var ieUrl = ieFormat
        ? "url".concat(assetResolver("./".concat(def.name, "/").concat(variant.assetName, ".").concat(ieFormat.fileExt)), "\"); /* IE */")
        : "";
    var urls = formats
        .filter(function (x) { return x.format; })
        .map(function (format) {
        return createFontUrl(def, variant.assetName, format, assetResolver);
    });
    var srcLine = "\n    ".concat(variant.localNames.join(", "), ",\n    ").concat(urls.join(", "), "\n  ");
    return "\n    ".concat(ieFormat ? "src: " + ieUrl : "", ";\n    src: ").concat(srcLine, ";\n  ");
}
function createFontUrl(def, assetName, format, assetResolver) {
    var assetPath = assetResolver("./".concat(def.name, "/").concat(assetName, ".").concat(format.fileExt));
    var fontUrl = assetPath;
    if (format.fileFragment) {
        fontUrl += "#" + format.fileFragment;
    }
    return "url(\"".concat(fontUrl, "\") format(\"").concat(format.format, "\")");
}
//# sourceMappingURL=utils.js.map